import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
// import p1 from 'assests/Photos/ClassAssembly/2B/1.jpg';
// import p2 from 'assests/Photos/ClassAssembly/2B/2.jpg';
// import p3 from 'assests/Photos/ClassAssembly/2B/3.jpg';
// import p4 from 'assests/Photos/ClassAssembly/2B/4.jpg';
// import p5 from 'assests/Photos/ClassAssembly/2B/5.jpg';
// import p6 from 'assests/Photos/ClassAssembly/2B/6.jpg';
// import p7 from 'assests/Photos/ClassAssembly/2B/7.jpg';
// import p8 from 'assests/Photos/ClassAssembly/2B/8.jpg';
// import p9 from 'assests/Photos/ClassAssembly/2B/9.jpg';
// import p10 from 'assests/Photos/ClassAssembly/2B/10.jpg';
// import p11 from 'assests/Photos/ClassAssembly/2B/11.jpg';
// import p12 from 'assests/Photos/ClassAssembly/2B/12.jpg';
// import p13 from 'assests/Photos/ClassAssembly/2B/13.jpg';
// import p14 from 'assests/Photos/ClassAssembly/2B/14.jpg';
// import p15 from 'assests/Photos/ClassAssembly/2B/15.jpg';



import { Typography } from '@mui/material';
import Container from 'components/Container';
import SidebarArticles from 'views/ClassAssembly3E/components/SidebarArticles/SidebarArticles';

const ClassAssembly2B = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_archive_url: '' });
  useEffect(() => {
    fetch('/config.json')  
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_archive_url}/academic-year-2022-23/home/events-activities/class-assembly/2B/1.webp`;
  const p2 = `${config.base_image_archive_url}/academic-year-2022-23/home/events-activities/class-assembly/2B/2.webp`;
  const p3 = `${config.base_image_archive_url}/academic-year-2022-23/home/events-activities/class-assembly/2B/3.webp`;
  const p4 = `${config.base_image_archive_url}/academic-year-2022-23/home/events-activities/class-assembly/2B/4.webp`;
  const p5 = `${config.base_image_archive_url}/academic-year-2022-23/home/events-activities/class-assembly/2B/5.webp`;
  const p6 = `${config.base_image_archive_url}/academic-year-2022-23/home/events-activities/class-assembly/2B/6.webp`;
  const p7 = `${config.base_image_archive_url}/academic-year-2022-23/home/events-activities/class-assembly/2B/7.webp`;
  const p8 = `${config.base_image_archive_url}/academic-year-2022-23/home/events-activities/class-assembly/2B/8.webp`;
  const p9 = `${config.base_image_archive_url}/academic-year-2022-23/home/events-activities/class-assembly/2B/9.webp`;
  const p10 = `${config.base_image_archive_url}/academic-year-2022-23/home/events-activities/class-assembly/2B/10.webp`;
  const p11 = `${config.base_image_archive_url}/academic-year-2022-23/home/events-activities/class-assembly/2B/11.webp`;
  const p12 = `${config.base_image_archive_url}/academic-year-2022-23/home/events-activities/class-assembly/2B/12.webp`;
  const p13 = `${config.base_image_archive_url}/academic-year-2022-23/home/events-activities/class-assembly/2B/13.webp`;
  const p14 = `${config.base_image_archive_url}/academic-year-2022-23/home/events-activities/class-assembly/2B/14.webp`;
  const p15 = `${config.base_image_archive_url}/academic-year-2022-23/home/events-activities/class-assembly/2B/15.webp`;


  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
      src: p2,
      source:p2,
      rows: 1,
      cols: 1,
    },
    {
      src: p3,
      source: p4,
      rows: 1,
      cols: 1,
    },
    {
      src: p4,
      source: p4,
      rows: 1,
      cols: 1,
    },
    {
        src: p5,
        source: p5,
        rows: 1,
        cols: 1,
      },
      {
        src: p6,
        source:p6,
        rows: 1,
        cols: 1,
      },
      {
        src: p7,
        source: p7,
        rows: 1,
        cols: 1,
      },
      {
        src: p8,
        source: p8,
        rows: 1,
        cols: 1,
      },
      {
        src: p9,
        source: p9,
        rows: 1,
        cols: 1,
      },
      {
        src: p10,
        source:p10,
        rows: 1,
        cols: 1,
      },
      {
        src: p11,
        source: p11,
        rows: 1,
        cols: 1,
      },
      {
        src: p12,
        source: p12,
        rows: 1,
        cols: 1,
      },
      {
        src: p13,
        source:p13,
        rows: 1,
        cols: 1,
      },
      {
        src: p14,
        source: p14,
        rows: 1,
        cols: 1,
      },
      {
        src: p15,
        source: p15,
        rows: 1,
        cols: 1,
      },


    // {
    //   src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   source: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      COLOURS
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
        CLASS 2B
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        Students of Class 2B got an opportunity to showcase their talent through a special assembly conducted on
Thursday, 27 October 2022 and Friday, 28 October 2022 on the topic ‘Colours’. The assembly began with a
prayer followed by greetings and thought for the day. The programme was a blend of dialogues, facts,
mime and dance. Through mime, the students displayed the difference between a colourful world and a
world without colours, just black and white. Students performed a colourful dance to convey the
significance of colours.
        </Typography>
      </Box>
      <Typography
          variant={'h4'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
          “Colours are the smiles of nature.”
<br/>
        </Typography>

      <Box>
        <ImageList
          variant="quilted"
          cols={3}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <SidebarArticles />
             </Box>
          
           {/* <SidebarNewsletter /> */}
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default ClassAssembly2B;